/*
 * Climbing Claus v3: motion and the buy flow. No libraries.
 * - reveals: one IntersectionObserver adds .is-in (CSS does the blur-rise, the tag swing, the seal press, the stamp)
 * - nav: gathers into a frosted island once the page scrolls
 * - snow: canvas snowfall in three depths (soft near flakes, mid, small sharp far ones), paused off-screen
 * - lights: string-light swags with lit C9 bulbs and an uneven flicker
 * - climb: a rAF loop (only while the section is on screen) reads scroll progress, swaps the photo, the tag and the
 *   copy per beat, and moves Santa up the photographic ladder, lighting it below him
 * - day/night compare, FAQ, delivery dates
 * - commerce: one selection (ladders + a light per ladder) shared by the buy box, the compact buy modules and the
 *   sticky bar; adds mixed lights as separate lines; the "Your sleigh" drawer (steppers, bundle saving from the
 *   cart's real discounts, make-it-two nudge, opt-in shipping protection); CTAs scroll to the nearest buy module
 * Decorative scripts (snow, lights, climb, parallax, compare sweep) start when the page is idle.
 * Reduced motion: no snow, no sweep, the climb is a static list.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  var $ = function (sel, el) {
    return (el || document).querySelector(sel);
  };
  var $$ = function (sel, el) {
    return Array.prototype.slice.call((el || document).querySelectorAll(sel));
  };
  var clamp = function (v, a, b) {
    return Math.min(b, Math.max(a, v));
  };
  var smooth = function (t) {
    return t * t * (3 - 2 * t);
  };

  /* ───────── reveals ───────── */
  function reveals() {
    var els = $$('[data-reveal], [data-swing], [data-press], [data-stamp], [data-reveal-class], [data-final]');
    if (!('IntersectionObserver' in window) || reduced) {
      els.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ───────── nav island ───────── */
  function nav() {
    var s = document.createElement('div');
    s.setAttribute('aria-hidden', 'true');
    s.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:90px;pointer-events:none;';
    document.body.prepend(s);
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (e) {
      root.classList.toggle('is-scrolled', !e[0].isIntersecting);
    }).observe(s);
  }

  /* ───────── hero drift (parallax while the hero is on screen) ───────── */
  function drift() {
    var el = $('[data-drift]');
    var hero = $('[data-hero]');
    if (!el || !hero || reduced) return;
    var on = true;
    var raf = 0;
    function loop() {
      var y = window.scrollY;
      el.style.transform = 'translate3d(0,' + (y * 0.16).toFixed(1) + 'px,0)';
      raf = on ? requestAnimationFrame(loop) : 0;
    }
    new IntersectionObserver(function (e) {
      on = e[0].isIntersecting;
      if (on && !raf) raf = requestAnimationFrame(loop);
    }).observe(hero);
  }

  /* ───────── snowfall ───────── */
  function snow() {
    if (reduced) return;
    var sprite = document.createElement('canvas');
    sprite.width = sprite.height = 64;
    var sc = sprite.getContext('2d');
    var g = sc.createRadialGradient(32, 32, 0, 32, 32, 32);
    g.addColorStop(0, 'rgba(255,255,255,1)');
    g.addColorStop(0.35, 'rgba(255,255,255,0.85)');
    g.addColorStop(0.7, 'rgba(255,255,255,0.22)');
    g.addColorStop(1, 'rgba(255,255,255,0)');
    sc.fillStyle = g;
    sc.fillRect(0, 0, 64, 64);

    $$('canvas[data-snow]').forEach(function (cv) {
      var density = parseFloat(cv.getAttribute('data-snow')) || 1;
      var ctx = cv.getContext('2d');
      var W = 0;
      var H = 0;
      var dpr = 1;
      var flakes = [];
      var on = false;
      var raf = 0;
      var t = 0;

      function make(layer, spawnTop) {
        var f = { layer: layer };
        if (layer === 0) {
          f.r = 0.7 + Math.random() * 1.1;
          f.vy = 0.35 + Math.random() * 0.35;
          f.a = 0.45 + Math.random() * 0.4;
          f.amp = 0.25;
        } else if (layer === 1) {
          f.r = 1.6 + Math.random() * 1.6;
          f.vy = 0.75 + Math.random() * 0.5;
          f.a = 0.55 + Math.random() * 0.35;
          f.amp = 0.5;
        } else {
          f.r = 7 + Math.random() * 9;
          f.vy = 1.5 + Math.random() * 1;
          f.a = 0.1 + Math.random() * 0.16;
          f.amp = 0.9;
        }
        f.x = Math.random() * W;
        f.y = spawnTop ? -f.r * 4 - Math.random() * 40 : Math.random() * H;
        f.ph = Math.random() * Math.PI * 2;
        f.fr = 0.006 + Math.random() * 0.01;
        return f;
      }
      function size() {
        var r = cv.getBoundingClientRect();
        dpr = Math.min(1.5, window.devicePixelRatio || 1);
        W = r.width;
        H = r.height;
        cv.width = Math.round(W * dpr);
        cv.height = Math.round(H * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var area = W * H;
        var counts = [Math.round((area / 7000) * density), Math.round((area / 22000) * density), Math.round((area / 140000) * density)];
        flakes = [];
        counts.forEach(function (c, layer) {
          for (var i = 0; i < c; i++) flakes.push(make(layer, false));
        });
      }
      function frame() {
        t += 1;
        ctx.clearRect(0, 0, W, H);
        var wind = Math.sin(t * 0.002) * 0.25 + 0.15;
        for (var i = 0; i < flakes.length; i++) {
          var f = flakes[i];
          f.y += f.vy;
          f.x += Math.sin(t * f.fr + f.ph) * f.amp + wind * (f.layer + 0.5) * 0.6;
          if (f.y > H + f.r * 4 || f.x < -40 || f.x > W + 40) {
            flakes[i] = make(f.layer, true);
            continue;
          }
          var d = f.r * (f.layer === 2 ? 2.4 : 2);
          ctx.globalAlpha = f.a;
          ctx.drawImage(sprite, f.x - d / 2, f.y - d / 2, d, d);
        }
        ctx.globalAlpha = 1;
        raf = on && !document.hidden ? requestAnimationFrame(frame) : 0;
      }
      function start() {
        if (on && !raf && !document.hidden) raf = requestAnimationFrame(frame);
      }
      size();
      var lastW = window.innerWidth;
      window.addEventListener('resize', function () {
        if (Math.abs(window.innerWidth - lastW) < 40 && flakes.length) return;
        lastW = window.innerWidth;
        size();
      });
      document.addEventListener('visibilitychange', start);
      new IntersectionObserver(function (e) {
        on = e[0].isIntersecting;
        if (on) {
          if (!W) size();
          start();
        }
      }).observe(cv);
    });
  }

  /* ───────── string lights ───────── */
  function lights() {
    var NS = 'http://www.w3.org/2000/svg';
    var glass = ['#fffbe9', '#ffe1a0', '#f2b04e', '#b8711f'];
    var uid = 0;
    function el(n, a) {
      var e = document.createElementNS(NS, n);
      for (var k in a) e.setAttribute(k, a[k]);
      return e;
    }
    function build(host) {
      var W = host.clientWidth;
      var H = host.clientHeight;
      if (!W) return;
      var id = 'l' + uid++;
      var svg = el('svg', { viewBox: '0 0 ' + W + ' ' + H, 'aria-hidden': 'true', focusable: 'false' });
      var defs = el('defs', {});
      var bg = el('radialGradient', { id: id + 'b', cx: '45%', cy: '55%', r: '62%' });
      [[0, glass[0]], [0.32, glass[1]], [0.72, glass[2]], [1, glass[3]]].forEach(function (s) {
        bg.appendChild(el('stop', { offset: s[0], 'stop-color': s[1] }));
      });
      var gg = el('radialGradient', { id: id + 'g' });
      [[0, 'rgba(255,206,130,.85)'], [0.25, 'rgba(255,200,120,.36)'], [0.6, 'rgba(255,190,110,.08)'], [1, 'rgba(255,190,110,0)']].forEach(function (s) {
        gg.appendChild(el('stop', { offset: s[0], 'stop-color': s[1] }));
      });
      defs.appendChild(bg);
      defs.appendChild(gg);
      svg.appendChild(defs);

      var swag = clamp(W / 6, 170, 260);
      var n = Math.max(2, Math.round(W / swag));
      swag = W / n;
      var sag = Math.min(30, swag * 0.15);
      var top = 6;
      var d = 'M0 ' + top;
      for (var i = 0; i < n; i++) d += ' Q' + (i * swag + swag / 2) + ' ' + (top + sag * 2) + ' ' + (i + 1) * swag + ' ' + top;
      svg.appendChild(el('path', { d: d, fill: 'none', stroke: '#0c1510', 'stroke-width': '2.2', 'stroke-linecap': 'round' }));
      svg.appendChild(el('path', { d: d, fill: 'none', stroke: 'rgba(255,230,190,.14)', 'stroke-width': '.8', transform: 'translate(0 -.8)' }));

      var per = Math.max(3, Math.round(swag / 50));
      var glows = el('g', {});
      var bulbs = el('g', {});
      for (i = 0; i < n; i++) {
        for (var j = 1; j <= per; j++) {
          var t = j / (per + 1);
          var x = i * swag + t * swag;
          var y = top + 2 * (1 - t) * t * sag * 2;
          var slope = ((1 - 2 * t) * sag * 4) / swag;
          var ang = Math.atan(slope) * 57.3 * 0.6 + (Math.random() - 0.5) * 14;
          var b = el('g', { transform: 'translate(' + x.toFixed(1) + ' ' + (y - 1).toFixed(1) + ') rotate(' + ang.toFixed(1) + ')' });
          b.appendChild(el('rect', { x: -3.6, y: 0, width: 7.2, height: 8.5, rx: 1.4, fill: '#1c2a22' }));
          b.appendChild(el('rect', { x: -3.6, y: 0, width: 2.2, height: 8.5, rx: 1, fill: 'rgba(255,255,255,.14)' }));
          b.appendChild(el('path', { d: 'M-4.6 8 C-7.6 11.5,-7 20,0 31.5 C7 20,7.6 11.5,4.6 8 Z', fill: 'url(#' + id + 'b)' }));
          b.appendChild(el('ellipse', { cx: -2.1, cy: 15, rx: 1.2, ry: 3.6, fill: 'rgba(255,255,255,.7)' }));
          bulbs.appendChild(b);
          var rad = ang / 57.3;
          var gl = el('circle', { cx: (x - Math.sin(rad) * 18).toFixed(1), cy: (y + 18).toFixed(1), r: 36, fill: 'url(#' + id + 'g)', class: 'bulb-glow' });
          gl.style.setProperty('--fd', (3.5 + Math.random() * 5).toFixed(2) + 's');
          gl.style.setProperty('--fdl', (-Math.random() * 6).toFixed(2) + 's');
          glows.appendChild(gl);
        }
      }
      svg.appendChild(glows);
      svg.appendChild(bulbs);
      host.innerHTML = '';
      host.appendChild(svg);
    }
    var hosts = $$('[data-lights]');
    hosts.forEach(build);
    var lastW = window.innerWidth;
    var tm = 0;
    window.addEventListener('resize', function () {
      if (Math.abs(window.innerWidth - lastW) < 40) return;
      lastW = window.innerWidth;
      clearTimeout(tm);
      tm = setTimeout(function () {
        hosts.forEach(build);
      }, 200);
    });
  }

  /* ───────── the climb ───────── */
  function climb() {
    var el = $('[data-climb]');
    if (!el) return;
    var beats = $$('[data-beat-copy]', el);
    var photos = $$('[data-ph]', el);
    var tags = $$('[data-beat-tag]', el);
    var rails = $$('[data-rail]', el);
    var count = $('[data-count]', el);
    var ladder = $('[data-ladder]', el);
    var lit = $('.ladder__lit', el);
    var santa = $('[data-santa]', el);
    var N = beats.length;
    if (!N) return;

    // rung geometry of the ladder photo (fractions of its height): the first (top) rung and the last
    var R_TOP = parseFloat(ladder.getAttribute('data-top')) || 0.1323;
    var R_BOT = parseFloat(ladder.getAttribute('data-bot')) || 0.9437;
    var RUNGS = 12;
    var R_START = 3.2; // Santa's hands start on the 4th rung from the bottom
    var R_END = RUNGS - 1; // and finish on the top rung
    function rungY(r) {
      // r = 0 is the bottom rung, RUNGS-1 the top one
      return R_BOT - (r / (RUNGS - 1)) * (R_BOT - R_TOP);
    }
    function rAt(p) {
      var t = clamp((p - 0.02) / 0.94, 0, 1);
      var raw = R_START + t * (R_END - R_START);
      var base = Math.floor(raw);
      return { r: base + smooth(raw - base), base: base, frac: raw - base };
    }

    var beat = -1;
    var target = 0;
    var cur = -1;
    var on = false;
    var raf = 0;
    var lH = 0;
    var sH = 0;
    var outT = [];

    function measure() {
      lH = ladder.offsetHeight;
      sH = santa.offsetHeight;
      // place the beat labels where Santa's hands are at the middle of each beat
      rails.forEach(function (li, k) {
        var s = rAt((k + 0.5) / N);
        li.style.top = (rungY(s.r) * 100).toFixed(2) + '%';
      });
    }

    function setBeat(b) {
      if (b === beat) return;
      var prev = beat;
      beat = b;
      [beats, photos, tags].forEach(function (list, li) {
        list.forEach(function (node, k) {
          if (k === b) {
            node.classList.remove('is-out');
            node.classList.add('is-on');
          } else if (node.classList.contains('is-on')) {
            node.classList.remove('is-on');
            if (li !== 1) {
              node.classList.add('is-out');
              clearTimeout(outT[li * 10 + k]);
              outT[li * 10 + k] = setTimeout(function () {
                node.classList.remove('is-out');
              }, 750);
            }
          }
        });
      });
      rails.forEach(function (r, k) {
        r.classList.toggle('is-on', k === b);
      });
      if (count) count.textContent = String(b + 1);
      return prev;
    }

    function render(p) {
      var s = rAt(p);
      var y = rungY(s.r) * lH;
      var lean = (s.base % 2 ? 1 : -1) * Math.sin(s.frac * Math.PI) * 3;
      santa.style.transform = 'translate3d(' + (lean * 0.6).toFixed(2) + 'px,' + (y - sH * 0.035).toFixed(1) + 'px,0) rotate(' + lean.toFixed(2) + 'deg)';
      santa.classList.toggle('is-flip', s.base % 2 === 1);
      // light the ladder from the bottom up to just above his hands
      var cut = clamp(rungY(s.r) - 0.04, 0, 1);
      if (p > 0.97) cut = 0;
      lit.style.clipPath = 'inset(' + (cut * 100).toFixed(2) + '% 0 0 0)';
      setBeat(Math.min(N - 1, Math.floor(p * N * 0.9999)));
    }

    function progress() {
      var r = el.getBoundingClientRect();
      var span = r.height - window.innerHeight;
      return span > 0 ? clamp(-r.top / span, 0, 1) : 0;
    }

    function loop() {
      target = progress();
      if (cur < 0) cur = target;
      cur += (target - cur) * 0.16;
      if (Math.abs(target - cur) < 0.0005) cur = target;
      render(cur);
      raf = on ? requestAnimationFrame(loop) : 0;
    }

    if (reduced) {
      // a static list: every beat shown, the ladder fully lit with Santa at the top
      el.classList.add('is-static');
      beats.forEach(function (b) {
        b.classList.add('is-on');
      });
      var still = function () {
        measure();
        santa.style.transform = 'translate3d(0,' + (rungY(R_END) * lH - sH * 0.035).toFixed(1) + 'px,0)';
        lit.style.clipPath = 'none';
      };
      still();
      window.addEventListener('load', still);
      return;
    }

    measure();
    render(0);
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    new IntersectionObserver(function (e) {
      on = e[0].isIntersecting;
      if (on && !raf) {
        measure();
        raf = requestAnimationFrame(loop);
      }
    }).observe(el);
  }

  /* ───────── day / night compare ───────── */
  function compare() {
    var cmp = $('[data-cmp]');
    if (!cmp) return;
    var range = $('[data-cmp-range]', cmp);
    var touched = false;
    function set(v) {
      cmp.style.setProperty('--cut', v + '%');
    }
    range.addEventListener('input', function () {
      touched = true;
      set(range.value);
    });
    if (reduced || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        // sweep once: show the day, then the night, then settle in the middle
        var keys = [
          [0, 50],
          [1300, 86],
          [2900, 14],
          [4100, 50]
        ];
        var t0 = performance.now() + 500;
        function step(now) {
          if (touched) return;
          var t = now - t0;
          if (t < 0) return requestAnimationFrame(step);
          for (var i = 1; i < keys.length; i++) {
            if (t <= keys[i][0]) {
              var a = keys[i - 1];
              var b = keys[i];
              var k = (t - a[0]) / (b[0] - a[0]);
              k = k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
              var v = a[1] + (b[1] - a[1]) * k;
              set(v.toFixed(2));
              range.value = Math.round(v);
              return requestAnimationFrame(step);
            }
          }
          set(50);
          range.value = 50;
        }
        requestAnimationFrame(step);
      },
      { threshold: 0.5 }
    );
    io.observe(cmp);
  }

  /* ───────── FAQ ───────── */
  function faq() {
    $$('.qa__q').forEach(function (q) {
      q.addEventListener('click', function () {
        q.setAttribute('aria-expanded', q.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      });
    });
  }

  /* ───────── delivery dates (calendar days from today) ───────── */
  function dates() {
    var fmt;
    try {
      fmt = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { month: 'short', day: 'numeric' });
    } catch (e) {
      return;
    }
    var day = function (n) {
      var d = new Date();
      d.setDate(d.getDate() + n);
      return d;
    };
    var businessDay = function (n) {
      var d = new Date();
      while (n > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) n--;
      }
      return d;
    };
    $$('[data-date]').forEach(function (el) {
      var raw = el.getAttribute('data-date');
      if (/b$/.test(raw)) {
        el.textContent = fmt.format(businessDay(parseInt(raw, 10)));
        return;
      }
      var parts = raw.split('-').map(Number);
      if (parts.length === 1) {
        el.textContent = fmt.format(day(parts[0]));
        return;
      }
      var a = day(parts[0]);
      var b = day(parts[1]);
      var same = a.getMonth() === b.getMonth();
      el.textContent = same ? fmt.format(a) + '–' + b.getDate() : fmt.format(a) + ' – ' + fmt.format(b);
    });
  }

  /* ───────── commerce: one selection shared by every buy module ───────── */
  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function commerce() {
    var dataEl = $('#cc-data');
    if (!dataEl) return;
    var D;
    try {
      D = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var T = D.text || {};
    var V = D.variants || [];
    if (!V.length) return;
    var byTitle = {};
    var byId = {};
    V.forEach(function (v) {
      byTitle[v.title] = v;
      byId[v.id] = v;
    });
    var names = V.map(function (v) {
      return v.title;
    });
    var unit = V[0].price;
    var compareAt = V[0].compare;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var main = $('[data-buy-module="main"]');
    var mainForm = main ? $('form[action*="/cart/add"]', main) : null;

    function offFor(q) {
      var off = 0;
      (D.tiers || []).forEach(function (t) {
        if (q >= t.qty) off = t.off;
      });
      return off;
    }

    /* the shared selection */
    var startQty = D.defaultQty || 1;
    var checkedTier = main ? $('input[name="quantity"][data-qty]:checked', main) : null;
    if (checkedTier) startQty = Number(checkedTier.getAttribute('data-qty'));
    var S = { qty: startQty, colours: [names[0], names[0], names[0]] };
    var subs = [];
    function emit(src) {
      subs.forEach(function (f) {
        f(src);
      });
    }
    function chosen() {
      return S.colours.slice(0, S.qty);
    }
    function isMixed() {
      var c = chosen();
      return c.some(function (x) {
        return x !== c[0];
      });
    }
    function totals() {
      var line = unit * S.qty;
      // the same rounding as Shopify's automatic discounts: the per-unit discount is rounded down
      var total = S.qty * (unit - Math.floor((unit * offFor(S.qty)) / 100));
      var was = S.qty > 1 ? line : compareAt;
      return { total: total, was: was };
    }
    function items() {
      var m = {};
      chosen().forEach(function (c) {
        m[c] = (m[c] || 0) + 1;
      });
      return Object.keys(m).map(function (k) {
        return { id: byTitle[k].id, quantity: m[k] };
      });
    }

    /* paint every bound element */
    function paint() {
      var t = totals();
      var light = isMixed() ? T.mixed : chosen()[0];
      $$('[data-sel-light]').forEach(function (el) {
        el.textContent = light;
      });
      $$('[data-sel-qty]').forEach(function (el) {
        el.textContent = S.qty + ' ' + (S.qty > 1 ? T.ladders : T.ladder);
      });
      $$('[data-sel-total]').forEach(function (el) {
        el.textContent = money(t.total);
      });
      $$('[data-sel-was]').forEach(function (el) {
        el.textContent = money(t.was);
        el.hidden = !(t.was > t.total);
      });
      $$('[data-sel-unit]').forEach(function (el) {
        el.textContent = money(unit);
      });
      $$('[data-sel-img]').forEach(function (el) {
        var src = byTitle[chosen()[0]].img;
        if (el.getAttribute('src') !== src) el.setAttribute('src', src);
      });
      $$('[data-light-pick]').forEach(function (b) {
        var v = b.getAttribute('data-light-pick');
        b.setAttribute('aria-pressed', !isMixed() && chosen()[0] === v ? 'true' : 'false');
      });
      $$('[data-qty-pick]').forEach(function (b) {
        b.setAttribute('aria-pressed', Number(b.getAttribute('data-qty-pick')) === S.qty ? 'true' : 'false');
      });
      if (main) {
        $$('input[name="quantity"][data-qty]', main).forEach(function (r) {
          r.checked = Number(r.getAttribute('data-qty')) === S.qty;
        });
        $$('[data-ladder-row]', main).forEach(function (row, i) {
          row.hidden = i >= S.qty;
          $$('input[data-colour]', row).forEach(function (r) {
            r.checked = r.value === S.colours[i];
          });
        });
        var mix = $('[data-mix-label]', main);
        if (mix) mix.textContent = S.qty > 1 ? (isMixed() ? T.mixed : chosen()[0]) : chosen()[0];
        var idIn = $('[data-variant-id]', main);
        if (idIn) idIn.value = byTitle[chosen()[0]].id;
        var express = $('[data-express]', main);
        var note = $('[data-mixed-note]', main);
        if (express) express.classList.toggle('is-hidden', isMixed());
        if (note) note.hidden = !isMixed();
      }
    }
    subs.push(paint);

    /* main gallery: thumbs, and picking a light shows it */
    var gimgs = main ? $$('.gal__main img', main) : [];
    var galReadyNow = function () {
      if (gimgs.length) root.classList.add('gal-ready');
    };
    var thumbs = main ? $$('[data-gal-thumb]', main) : [];
    function show(k) {
      if (k > 0) galReadyNow();
      gimgs.forEach(function (im, j) {
        if (j === k) im.loading = 'eager';
        im.classList.toggle('is-on', j === k);
      });
      thumbs.forEach(function (x, j) {
        x.setAttribute('aria-current', j === k ? 'true' : 'false');
      });
    }
    if (gimgs.length) show(0);
    var galReady = function () {
      root.classList.add('gal-ready');
    };
    if (document.readyState === 'complete') idle(galReady);
    else window.addEventListener('load', function () {
      idle(galReady);
    });
    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () {
        show(k);
      });
    });
    function showLight(value) {
      var key = /multi/i.test(value) ? 'multi' : 'warm';
      for (var i = 0; i < gimgs.length; i++) {
        if (gimgs[i].getAttribute('data-light') === key) return show(i);
      }
    }

    /* inputs */
    if (main) {
      $$('input[name="quantity"][data-qty]', main).forEach(function (r) {
        r.addEventListener('change', function () {
          if (r.checked) {
            S.qty = Number(r.getAttribute('data-qty'));
            emit();
          }
        });
      });
      $$('[data-ladder-row]', main).forEach(function (row, i) {
        $$('input[data-colour]', row).forEach(function (r) {
          r.addEventListener('change', function () {
            if (!r.checked) return;
            S.colours[i] = r.value;
            showLight(r.value);
            emit();
          });
        });
      });
    }
    document.addEventListener('click', function (e) {
      var lp = e.target.closest('[data-light-pick]');
      if (lp) {
        var v = lp.getAttribute('data-light-pick');
        S.colours = [v, v, v];
        showLight(v);
        emit();
        return;
      }
      var qp = e.target.closest('[data-qty-pick]');
      if (qp) {
        var q = Number(qp.getAttribute('data-qty-pick'));
        for (var i = S.qty; i < q; i++) S.colours[i] = S.colours[S.qty - 1];
        S.qty = q;
        emit();
        return;
      }
      var add = e.target.closest('[data-add-sel]');
      if (add) {
        addSelection(add);
        return;
      }
      var cta = e.target.closest('[data-cta]');
      if (cta) {
        e.preventDefault();
        toNearestModule();
      }
    });

    /* cart requests */
    function post(url, body) {
      return fetch(base + url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw j;
          return j;
        });
      });
    }
    function addSelection(btn) {
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      }
      var msg = main ? $('[data-msg]', main) : null;
      if (msg) {
        msg.textContent = '';
        msg.classList.remove('is-err');
      }
      return post('cart/add.js', { items: items() })
        .then(function () {
          return drawer.open();
        })
        .catch(function (err) {
          var text = (err && (err.description || err.message)) || T.error;
          if (msg && main.contains(btn)) {
            msg.textContent = text;
            msg.classList.add('is-err');
          } else {
            window.alert(text);
          }
        })
        .then(function () {
          if (btn) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          }
        });
    }
    if (mainForm) {
      mainForm.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        addSelection($('[data-add]', mainForm));
      });
    }

    function toNearestModule() {
      var mods = $$('[data-buy-module]');
      if (!mods.length) return;
      var best = mods[0];
      var bestD = Infinity;
      mods.forEach(function (m) {
        var r = m.getBoundingClientRect();
        var d = Math.abs(r.top + r.height / 2 - window.innerHeight / 2);
        if (d < bestD) {
          bestD = d;
          best = m;
        }
      });
      var target = best.getAttribute('data-buy-module') === 'main' ? $('.buy__panel', best) || best : $('.mini__card', best) || best;
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: best.getAttribute('data-buy-module') === 'main' ? 'start' : 'center' });
    }

    /* ── the drawer: Your sleigh ── */
    var drawer = (function () {
      var el = $('[data-drawer]');
      if (!el) {
        return {
          open: function () {
            window.location.href = base + 'cart';
          },
          refresh: function () {}
        };
      }
      var panel = $('.drawer__panel', el);
      var linesEl = $('[data-lines]', el);
      var empty = $('[data-empty]', el);
      var foot = $('[data-foot]', el);
      var nudge = $('[data-nudge]', el);
      var prot = $('[data-protect]', el);
      var protWrap = $('[data-protect-wrap]', el);
      var P = D.protection;
      var cart = null;
      var lastFocus = null;
      var isOpen = false;
      if (P && $('[data-protect-price]', el)) $('[data-protect-price]', el).textContent = money(P.price);

      function isLadder(it) {
        return !!byId[it.variant_id];
      }
      function protItem() {
        return P && cart ? cart.items.filter(function (it) {
          return it.variant_id === P.id;
        })[0] : null;
      }
      function ladderCount() {
        return cart ? cart.items.filter(isLadder).reduce(function (n, it) {
          return n + it.quantity;
        }, 0) : 0;
      }
      function refresh() {
        return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.json();
          })
          .then(function (c) {
            cart = c;
            return tidy();
          })
          .then(render);
      }
      /* protection never outlives the ladders, and is never more than one */
      function tidy() {
        var p = protItem();
        if (!p) return Promise.resolve();
        var n = ladderCount();
        if (!n || p.quantity > 1) {
          return post('cart/change.js', { id: p.key, quantity: n ? 1 : 0 }).then(function (c) {
            cart = c;
          });
        }
        return Promise.resolve();
      }
      function render() {
        if (!cart) return;
        var n = ladderCount();
        var p = protItem();
        var ladders = cart.items.filter(isLadder);
        linesEl.innerHTML = ladders
          .map(function (it) {
            var v = byId[it.variant_id];
            var img = (v && v.img) || (it.image || '');
            var struck = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
            return (
              '<li class="line-item">' +
              '<img src="' + esc(img) + '" alt="" width="72" height="72" loading="lazy">' +
              '<p class="line-item__t"><b>' + esc(it.product_title) + '</b><span>' + esc(it.variant_title || '') + '</span></p>' +
              '<div class="line-item__p"><b>' + money(it.final_line_price) + '</b>' + struck +
              '<span class="step"><button type="button" data-step="-1" data-key="' + esc(it.key) + '" data-q="' + it.quantity + '" aria-label="' + esc(T.decrease) + '">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-step="1" data-key="' + esc(it.key) + '" data-q="' + it.quantity + '" aria-label="' + esc(T.increase) + '">+</button></span></div>' +
              '</li>'
            );
          })
          .join('');
        empty.hidden = n > 0;
        foot.hidden = n === 0;
        nudge.hidden = n !== 1;
        if (protWrap) protWrap.hidden = !P || n === 0;
        if (prot) prot.checked = !!p;
        var original = ladders.reduce(function (s, it) {
          return s + it.original_line_price;
        }, 0);
        var saving = ladders.reduce(function (s, it) {
          return s + (it.original_line_price - it.final_line_price);
        }, 0);
        $('[data-t-original]', el).textContent = money(original);
        $('[data-t-save-row]', el).hidden = saving <= 0;
        $('[data-t-save]', el).textContent = '−' + money(saving);
        var protRow = $('[data-t-prot-row]', el);
        if (protRow) {
          protRow.hidden = !p;
          if (p) $('[data-t-prot]', el).textContent = money(p.final_line_price);
        }
        $('[data-t-total]', el).textContent = money(cart.total_price);
        var count = $('[data-cart-count]');
        if (count) {
          count.textContent = n;
          count.hidden = !n;
        }
      }
      function change(key, q) {
        el.setAttribute('aria-busy', 'true');
        return post('cart/change.js', { id: key, quantity: q })
          .then(function (c) {
            cart = c;
            return tidy();
          })
          .then(render)
          .catch(function () {
            return refresh();
          })
          .then(function () {
            el.removeAttribute('aria-busy');
          });
      }
      linesEl.addEventListener('click', function (e) {
        var b = e.target.closest('[data-step]');
        if (!b) return;
        var q = Number(b.getAttribute('data-q')) + Number(b.getAttribute('data-step'));
        change(b.getAttribute('data-key'), Math.max(0, q));
      });
      if (nudge) {
        $('[data-nudge-add]', nudge).addEventListener('click', function () {
          var one = cart && cart.items.filter(isLadder)[0];
          if (!one) return;
          el.setAttribute('aria-busy', 'true');
          post('cart/add.js', { items: [{ id: one.variant_id, quantity: 1 }] })
            .then(refresh)
            .then(function () {
              el.removeAttribute('aria-busy');
            });
        });
      }
      if (prot && P) {
        prot.addEventListener('change', function () {
          var p = protItem();
          el.setAttribute('aria-busy', 'true');
          var req = prot.checked
            ? p
              ? Promise.resolve()
              : post('cart/add.js', { items: [{ id: P.id, quantity: 1 }] })
            : p
              ? post('cart/change.js', { id: p.key, quantity: 0 })
              : Promise.resolve();
          req.then(refresh).then(function () {
            el.removeAttribute('aria-busy');
          });
        });
      }
      function open() {
        lastFocus = document.activeElement;
        el.hidden = false;
        isOpen = true;
        root.classList.add('is-drawer-open');
        updateBar();
        requestAnimationFrame(function () {
          el.classList.add('is-open');
          panel.focus({ preventScroll: true });
        });
        return refresh();
      }
      function close() {
        if (!isOpen) return;
        isOpen = false;
        el.classList.remove('is-open');
        root.classList.remove('is-drawer-open');
        updateBar();
        setTimeout(function () {
          if (!isOpen) el.hidden = true;
        }, 650);
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }
      $$('[data-drawer-close]', el).forEach(function (b) {
        b.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (!isOpen) return;
        if (e.key === 'Escape') close();
        if (e.key === 'Tab') {
          var f = $$('button, [href], input, [tabindex]:not([tabindex="-1"])', panel).filter(function (x) {
            return x.offsetParent !== null && !x.disabled;
          });
          if (!f.length) return;
          if (e.shiftKey && document.activeElement === f[0]) {
            e.preventDefault();
            f[f.length - 1].focus();
          } else if (!e.shiftKey && document.activeElement === f[f.length - 1]) {
            e.preventDefault();
            f[0].focus();
          }
        }
      });
      $$('.nav__cart').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          open();
        });
      });
      return {
        open: open,
        close: close,
        refresh: refresh,
        isOpen: function () {
          return isOpen;
        }
      };
    })();

    /* ── the sticky bar ── */
    var bar = $('[data-sbar]');
    var vis = new Map();
    var passed = false;
    function updateBar() {
      if (!bar) return;
      var any = false;
      vis.forEach(function (v) {
        if (v) any = true;
      });
      var on = passed && !any && !(drawer.isOpen && drawer.isOpen());
      bar.classList.toggle('is-on', on);
      root.classList.toggle('has-sbar', on);
    }
    if (bar && 'IntersectionObserver' in window) {
      var watched = $$('[data-buy-module]');
      var fin = $('[data-final]');
      if (fin) watched.push(fin);
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            vis.set(e.target, e.isIntersecting);
            if (e.target === main) passed = !e.isIntersecting && e.boundingClientRect.top < 0;
          });
          if (!main) passed = window.scrollY > window.innerHeight;
          updateBar();
        },
        { rootMargin: '-12% 0px -12% 0px' }
      );
      watched.forEach(function (w) {
        io.observe(w);
      });
    }

    emit();
    drawer.refresh && fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        var n = c.items.filter(function (it) {
          return !!byId[it.variant_id];
        }).reduce(function (s, it) {
          return s + it.quantity;
        }, 0);
        var count = $('[data-cart-count]');
        if (count) {
          count.textContent = n;
          count.hidden = !n;
        }
      })
      .catch(function () {});
  }

  /* start the heavy, decorative work once the page is idle (the buy flow starts at once) */
  function idle(fn) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 1800 });
    else setTimeout(fn, 400);
  }

  function init() {
    reveals();
    nav();
    faq();
    dates();
    commerce();
    idle(function () {
      drift();
      snow();
      lights();
      climb();
      compare();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
